import { createAction } from '@reduxjs/toolkit'

export const selectPercent = createAction<{ percent: number }>('burnCharm/selectBurnPercent')
export const setSlippageTolerance = createAction<{ slippageTolerance: number }>('burnCharm/setSlippageTolerance')
